import React, { useState, useEffect } from 'react';
import { Box, Grid, TextField, Typography, Button } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import { toast } from 'react-toastify';
import {
  validateMetaTitle,
  validateMetaDescription,
  restrictInputLength
} from './setting-validation';
import { getMetaTitleStatus, getMetaDescriptionStatus } from './setting-validation';
import palette from 'src/theme/palette';
import { postSettingData } from 'src/ApiServices';

const StaticPagesSEOTab = ({ tabData = [], typeId }) => {
  const getInitialFormData = () => {
    const dataMap = {};
    tabData.forEach((item) => {
      dataMap[item.key] = {
        id: item.id || '',
        value: item.value || ''
      };
    });

    const pageKeys = [
      'about',
      'contact',
      'search',
      'faqs',
      'blogs',
      'properties',
      // 'property_details',
      'valuation',
      'market_insights'
    ];

    const initialData = {};

    pageKeys.forEach((pageKey) => {
      initialData[`${pageKey}_meta_title`] = dataMap[`${pageKey}_meta_title`] || {
        id: '',
        value: ''
      };
      initialData[`${pageKey}_meta_description`] = dataMap[`${pageKey}_meta_description`] || {
        id: '',
        value: ''
      };
    });

    return initialData;
  };

  const [formData, setFormData] = useState(getInitialFormData());
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  // Update formData when tabData changes
  useEffect(() => {
    setFormData(getInitialFormData());
  }, [tabData]);

  const handleSaveSettings = async () => {
    setLoading(true);

    const valueArray = Object.keys(formData).map((key) => {
      const field = formData[key];
      return {
        id: field.id || null,
        key: key,
        value: field.value,
        content_type: null,
        file: null,
        type_id: typeId,
        type: 'Static Pages SEO',
        created_at: field.id ? new Date().toISOString() : null,
        updated_at: new Date().toISOString().replace('T', ' ').substring(0, 19)
      };
    });

    const finalPayload = {
      type_id: typeId.toString(),
      value: JSON.stringify(valueArray)
    };

    try {
      const response = await postSettingData(finalPayload);

      // Success handling
      const message =
        response?.message ||
        response?.data?.message ||
        'Static pages SEO settings saved successfully!';

      toast.success(message, {
        position: 'top-right',
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
      });
    } catch (error) {
      console.error('Save Error:', error);

      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        'Failed to save settings. Please try again.';

      toast.error(errorMessage, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
      });
    } finally {
      setLoading(false);
    }
  };

  // const handleInputChange = (fieldName, value) => {
  //   // Apply character limits based on field type
  //   let trimmedValue = value;
  //   if (fieldName.includes('meta_title') && value.length > 120) {
  //     trimmedValue = value.substring(0, 120);
  //   } else if (fieldName.includes('meta_description') && value.length > 160) {
  //     trimmedValue = value.substring(0, 160);
  //   }

  //   setFormData((prev) => ({
  //     ...prev,
  //     [fieldName]: {
  //       ...prev[fieldName],
  //       value: trimmedValue
  //     }
  //   }));

  //   // Validate after trimming
  //   let error = '';
  //   if (fieldName.includes('meta_title')) {
  //     error = validateMetaTitle(trimmedValue);
  //   } else if (fieldName.includes('meta_description')) {
  //     error = validateMetaDescription(trimmedValue);
  //   }

  //   setErrors((prev) => ({
  //     ...prev,
  //     [fieldName]: error
  //   }));
  // };

  const handleInputChange = (fieldName, value) => {
    setFormData((prev) => ({
      ...prev,
      [fieldName]: {
        ...prev[fieldName],
        value
      }
    }));
  };

  const pageConfig = [
    { key: 'about', label: 'About Page' },
    { key: 'contact', label: 'Contact Page' },
    { key: 'search', label: 'Search Page' },
    { key: 'faqs', label: 'FAQs Page' },
    { key: 'blogs', label: 'Blogs Page' },
    { key: 'properties', label: 'Properties Page' },
    // { key: 'property_details', label: 'Property Details Page' },
    { key: 'valuation', label: 'Valuation Page' },
    { key: 'market_insights', label: 'Market Insights Page' }
  ];
  // const metaTitleValue = formData[`${page.key}_meta_title`]?.value || '';
  // const metaTitleStatus = getMetaTitleStatus(metaTitleValue);

  // const metaDescValue = formData[`${page.key}_meta_description`]?.value || '';
  // const metaDescStatus = getMetaDescriptionStatus(metaDescValue);
  return (
    <Box>
      <Grid container spacing={3}>
        {pageConfig.map((page) => {
          // Move these variable declarations inside the map function
          const metaTitleValue = formData[`${page.key}_meta_title`]?.value || '';
          const metaTitleStatus = getMetaTitleStatus(metaTitleValue);
          const metaDescValue = formData[`${page.key}_meta_description`]?.value || '';
          const metaDescStatus = getMetaDescriptionStatus(metaDescValue);

          return (
            <Grid item xs={12} key={page.key}>
              <Typography variant="h6" gutterBottom>
                {page.label}
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  {/* <TextField
                  fullWidth
                  label="Meta Title"
                  value={formData[`${page.key}_meta_title`]?.value || ''}
                  onChange={(e) => handleInputChange(`${page.key}_meta_title`, e.target.value)}
                  onKeyPress={(e) => restrictInputLength(e, 120)}
                  placeholder={`Enter meta title for ${page.label.toLowerCase()}`}
                  error={!!errors[`${page.key}_meta_title`]}
                  helperText={
                    errors[`${page.key}_meta_title`] ||
                    `${formData[`${page.key}_meta_title`]?.value?.length || 0}/120`
                  }
                  inputProps={{ maxLength: 120 }}
                /> */}

                  <TextField
                    fullWidth
                    label="Meta Title"
                    value={metaTitleValue}
                    onChange={(e) => handleInputChange(`${page.key}_meta_title`, e.target.value)}
                    placeholder="Home For Sale in Pittsburgh PA | Brand"
                    helperText={
                      <>
                        <Typography variant="caption" color={metaTitleStatus.color}>
                          {metaTitleStatus.message}
                        </Typography>
                        <br />
                        <Typography variant="caption" color="text.secondary">
                          • Ideal: 50–60 characters • Use Title Case • Include keywords • End with
                          brand/company name
                        </Typography>
                      </>
                    }
                  />
                </Grid>
                <Grid item xs={12}>
                  {/* <TextField
                  fullWidth
                  multiline
                  minRows={2}
                  label="Meta Description"
                  value={formData[`${page.key}_meta_description`]?.value || ''}
                  onChange={(e) =>
                    handleInputChange(`${page.key}_meta_description`, e.target.value)
                  }
                  placeholder={`Enter meta description for ${page.label.toLowerCase()}`}
                  error={!!errors[`${page.key}_meta_description`]}
                  helperText={
                    errors[`${page.key}_meta_description`] ||
                    `${formData[`${page.key}_meta_description`]?.value?.length || 0}/160`
                  }
                  inputProps={{ maxLength: 160 }}
                /> */}

                  <TextField
                    fullWidth
                    multiline
                    minRows={2}
                    label="Meta Description"
                    value={metaDescValue}
                    onChange={(e) =>
                      handleInputChange(`${page.key}_meta_description`, e.target.value)
                    }
                    placeholder="Find homes for sale with expert agents..."
                    helperText={
                      <Typography variant="caption" color={metaDescStatus.color}>
                        {metaDescStatus.message}
                      </Typography>
                    }
                  />
                </Grid>
              </Grid>
            </Grid>
          );
        })}

        <Grid item xs={12} container justifyContent="flex-end">
          <Button
            variant="contained"
            startIcon={<SaveIcon />}
            onClick={handleSaveSettings}
            sx={{
              background: palette.primary.main,
              color: palette.primary.contrastText,
              height: 40,
              '&:hover': { background: palette.primary.dark }
            }}
          >
            Save Settings
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default StaticPagesSEOTab;
